import { Trash2 } from 'lucide-react';
import { currency } from '../pharmacy/Utility/currency';



export default function ItemsTable({ items, onQty, onDiscount, onGst, onRemove }) {
  if (!items?.length) return null;

  return (
    <div style={{ padding: '20px', borderBottom: '1px solid #e2e8f0' }}>
      <h2 style={{ fontSize: '13px', fontWeight: 700, color: '#1f2937', margin: '0 0 12px 0', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
        Order Items ({items.length})
      </h2>

      <div style={{ overflowX: 'auto', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
          <thead>
            <tr style={{ background: '#f9fafb', borderBottom: '2px solid #e5e7eb' }}>
              <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 700, color: '#374151' }}>PRODUCT</th>
              <th style={{ padding: '10px 12px', textAlign: 'center', fontWeight: 700, color: '#374151', minWidth: '60px' }}>QTY</th>
              <th style={{ padding: '10px 12px', textAlign: 'right', color: '#6b7280', fontSize: '13px', minWidth: '90px' }}>MRP</th>
              <th style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 700, color: '#1f2937', minWidth: '90px' }}>SALE RT</th>
              <th style={{ padding: '10px 12px', textAlign: 'center', fontWeight: 700, color: '#374151', minWidth: '70px' }}>DISC %</th>
              <th style={{ padding: '10px 12px', textAlign: 'center', fontWeight: 700, color: '#374151', minWidth: '60px' }}>GST %</th>
              <th style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 700, color: '#374151', minWidth: '100px' }}>AMOUNT</th>
              <th style={{ padding: '10px 12px', textAlign: 'center', fontWeight: 700, color: '#374151', minWidth: '60px' }} />
            </tr>
          </thead>
          <tbody>
            {items.map((item, idx) => (
              <tr
                key={item.id}
                style={{ borderBottom: '1px solid #e5e7eb', background: idx % 2 === 0 ? '#fff' : '#fafbfc', transition: 'background 0.2s' }}
                onMouseEnter={(e) => (e.currentTarget.style.background = '#f0fdf4')}
                onMouseLeave={(e) => (e.currentTarget.style.background = idx % 2 === 0 ? '#fff' : '#fafbfc')}
              >
                <td style={{ padding: '10px 12px' }}>
                  <div style={{ fontWeight: 600, color: '#1f2937', fontSize: '13px' }}>{item.productname}</div>
                  <div style={{ fontSize: '11px', color: '#999', marginTop: '2px' }}>{item.company}</div>
                </td>
                <td style={{ padding: '10px 12px', textAlign: 'center' }}>
                  <input
                    type="number"
                    min="1"
                    value={item.qty}
                    onChange={(e) => onQty(item.id, parseInt(e.target.value))}
                    style={{ width: '50px', padding: '4px 6px', border: '1px solid #d1d5db', borderRadius: '4px', textAlign: 'center', fontSize: '13px', fontWeight: 600, boxSizing: 'border-box', outline: 'none' }}
                  />
                </td>
                <td style={{ padding: '10px 12px', textAlign: 'right', color: '#6b7280', fontSize: '13px' }}>
                  {currency(item.mrp)}
                </td>
                <td style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 600, color: '#1f2937', fontSize: '13px' }}>
                  {currency(item.saleRate)}
                </td>
                <td style={{ padding: '10px 12px', textAlign: 'center' }}>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    value={item.discount}
                    onChange={(e) => onDiscount(item.id, parseFloat(e.target.value) || 0)}
                    style={{ width: '50px', padding: '4px 6px', border: '1px solid #d1d5db', borderRadius: '4px', textAlign: 'center', fontSize: '13px', fontWeight: 600, boxSizing: 'border-box', outline: 'none' }}
                  />
                </td>
                <td style={{ padding: '10px 12px', textAlign: 'center' }}>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    value={item.gstPct}
                    onChange={(e) => onGst(item.id, parseFloat(e.target.value) || 0)}
                    style={{ width: '50px', padding: '4px 6px', border: '1px solid #d1d5db', borderRadius: '4px', textAlign: 'center', fontSize: '13px', fontWeight: 600, boxSizing: 'border-box', outline: 'none' }}
                  />
                </td>
                <td style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 700, color: '#10b981', fontSize: '13px' }}>
                  {currency(item.amount)}
                </td>
                <td style={{ padding: '10px 12px', textAlign: 'center' }}>
                  <button
                    onClick={() => onRemove(item.id)}
                    style={{ background: '#fee2e2', color: '#dc2626', border: 'none', borderRadius: '4px', padding: '6px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s' }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = '#fecaca')}
                    onMouseLeave={(e) => (e.currentTarget.style.background = '#fee2e2')}
                  >
                    <Trash2 size={14} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
